import * as React from "react";
import {
    RangedDatePickerWithOptions,
    RangedDatePickerWithOptionsOptions,
} from "../../../../components/rangeddatepicker/RangedDatePickerWithOptions";
// tslint:disable:max-line-length
import RangedDatePickerWithOptionsController from "../../../../components/rangeddatepicker/RangedDatePickerWithOptionsController";
import {I18n} from "../../../../components/Utils/i18n";
import {AppTranslations} from "../../../../components/Utils/translations/AppTranslations";
import {
    borderRadius,
    ColorPalette, getChipColor,
    getLegacyChipColor,
    renderCheckBox,
    SpecificAlarmFilterProps, toTimezone,
} from "./Commons";
import {ExpandableChipButton} from "../../../../components/buttons/ExpandableChipButton";

declare var LOCALE: string;
declare var AppTranslations: AppTranslations;

export interface FilterDefaultOption {
    pending: number;
    managed: number;
    closed: number;
    alwaysFirst?: boolean;
}

export interface AlarmStateFilterProps extends SpecificAlarmFilterProps {
    optionsDefaults: FilterDefaultOption;
}

interface AlarmStateFilterState {
    didOptionClosedBackToDefault: boolean;
}

export class AlarmStateFilter extends React.Component<AlarmStateFilterProps, AlarmStateFilterState> {

    private static renderStateThumbnail = (url, percentage: number) => {
        return (
            <div className={"circle"} style={{filter: "invert(" + percentage + ")"}}>
                <img className={"thumbnail-image"} src={url} style={{filter: "brightness(0)"}}/>
            </div>
        );
    }

    private statesAlarmPeriodControllers: any;

    constructor(props) {
        super(props);
        this.statesAlarmPeriodControllers = {
            pending: new RangedDatePickerWithOptionsController({}),
            managed: new RangedDatePickerWithOptionsController({}),
            closed: new RangedDatePickerWithOptionsController({}),
        };
        this.props.resetter((optionsDefaults: FilterDefaultOption) => {
            Object.keys(this.statesAlarmPeriodControllers).forEach((id) => {
                this.statesAlarmPeriodControllers[id].changeOption(optionsDefaults[id]);
            });
        });

        this.state = {
            didOptionClosedBackToDefault: !this.props.optionsDefaults.alwaysFirst,
        };
    }

    public componentDidMount() {
        Object.keys(this.statesAlarmPeriodControllers).forEach((id) => {
            this.statesAlarmPeriodControllers[id].listen((range) => {
                const newFilter = {...this.props.filter};
                newFilter.alarmState[id].lookupPeriod = range;
                this.props.onFilterConfigChanged(newFilter);
            });
        });
    }

    public render() {
        return (
            <div className={"filter-form-column"}>
                <p className={"filter-field-name"}>{AppTranslations.equipmentAlarmFilter.stateLabel}</p>
                <div className={"group-wrapper possible-states"}>
                    {this.renderStateComponents(
                        AppTranslations.equipmentAlarmFilter.statePendingLabel,
                        "images/glyphicons/iconAlarm-OpenWihtOutWo.png",
                        "pending",
                        this.props.optionsDefaults.pending,
                    )}
                    {this.renderStateComponents(
                        AppTranslations.equipmentAlarmFilter.stateManagedLabel,
                        "images/glyphicons/iconAlarm-workOrderAlarm.png",
                        "managed",
                        this.props.optionsDefaults.managed,
                    )}
                    {this.renderStateComponents(
                        AppTranslations.equipmentAlarmFilter.stateCloseLabel,
                        "images/glyphicons/iconAlarm-alarmClose.png",
                        "closed",
                        this.props.optionsDefaults.closed,
                        !this.state.didOptionClosedBackToDefault ? 0 : undefined,
                    )}
                </div>
            </div>
        );
    }

    private renderStateComponents =
        (title: string, thumbnailURL: string, id: string, defaultOption: number, initialOption?: number) => {
            return (
                <div className={"row-box"}>
                    <ExpandableChipButton
                        title={title}
                        onChange={this.onAlarmStateChange(id)}
                        checked={this.props.filter.alarmState[id].active}
                        disabled={this.props.disabled}
                        color={getChipColor(this.props.disabled, this.props.filter.alarmState[id].active)}
                        fitTitleFitParent={true}
                        accentColor={"var(--blue)"}
                    >
                            <div className="state-date-wrapper">
                                <RangedDatePickerWithOptions
                                    fromLabel={AppTranslations.equipmentAlarmFilter.stateDateFromLabel}
                                    toLabel={AppTranslations.equipmentAlarmFilter.stateDateToLabel}
                                    options={this.props.selectionOptions}
                                    defaultOption={initialOption !== undefined ? initialOption : defaultOption}
                                    controller={this.statesAlarmPeriodControllers[id]}
                                    customText={AppTranslations.equipmentAlarmFilter.customOptionLabel}
                                    disabled={this.props.disabled}
                                    dateFormat={I18n.getLocaleDateFormat(LOCALE)}
                                    locale={LOCALE}
                                    maxDate={new Date()}
                                    useETUIcomponent={true}
                                />
                            </div>
                    </ExpandableChipButton>
                </div>
            );
    }

    private onAlarmStateChange = (id: string) => {
        return (_) => {
            const futureAlarmState = {
                ...this.props.filter.alarmState,
                [id]: {
                    ...this.props.filter.alarmState[id],
                    active: !this.props.filter.alarmState[id].active,
                },
            };
            if (!futureAlarmState.pending.active && !futureAlarmState.managed.active && !futureAlarmState.closed.active) {
                return;
            }

            this.setState({
                didOptionClosedBackToDefault: this.state.didOptionClosedBackToDefault || id === "closed",
            }, () => {
                this.props.onFilterConfigChanged({
                    ...this.props.filter,
                    alarmState: {
                        ...this.props.filter.alarmState,
                        [id]: {
                            active: !this.props.filter.alarmState[id].active,
                            lookupPeriod: this.props.selectionOptions[this.props.optionsDefaults[id]].optionRange,
                        },
                    },
                });
            });
        };
    }
}
